import * as Sentry from "@sentry/remix";
import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";
import { sentryProjectId, sentryAuthToken, posthogProjectId } from "./sentryAndPosthogConstants";
import posthog from "posthog-js";
import { useScript } from "./hooks/useScript";


const shouldActivateSentryAndPosthog = (window.location.hostname !== "localhost")
console.log(`Pikachu status: ${shouldActivateSentryAndPosthog}.. pika pika..`)

const sentryDsn = `https://${sentryAuthToken}@o1364638.ingest.us.sentry.io/${sentryProjectId}`;

function PosthogInit() {
  useEffect(() => {
    posthog.init(posthogProjectId, {
      api_host: '/p',
      ui_host: 'https://eu.posthog.com',
      // person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
    });
  }, []);
  return null;
}

if (shouldActivateSentryAndPosthog) {
  Sentry.init({
    dsn: sentryDsn,
    tracesSampleRate: 1,
    beforeSend(event, hint) {
      // Check if it is an exception, and if so, show the report dialog
      // if (event.exception && event.event_id) {
      //   Sentry.showReportDialog({ eventId: event.event_id });
      // }
      return event;
    },

    integrations: [
      Sentry.browserTracingIntegration({
        useEffect,
        useLocation,
        useMatches
      }),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true
      }),
      // Sentry.feedbackIntegration({
      //   colorScheme: "system",
      //   showBranding: false,
      //   triggerLabel: "",
      //   nameLabel: "Your awesome name",

      //   formTitle: "Help us make Boosted Pins even better!",

      //   showName: false,

      //   // namePlaceholder: "Superhero name goes here",
      //   emailLabel: "Your email (for good karma points, optional ✨)",
      //   emailPlaceholder: "superhero@email.com",
      //   messageLabel: "What's on your mind? Ideas? Bugs?",
      //   messagePlaceholder: "Tell us your story - every bug fixed or feature added makes the app more magical ✨",
      //   addScreenshotButtonLabel: "📸 Show us what you mean",
      //   removeScreenshotButtonLabel: "Remove image",
      //   submitButtonLabel: "✨ Send!",
      //   cancelButtonLabel: "Maybe later",
      //   confirmButtonLabel: "Yes, send it!",
      // }),
    ],

    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1,

    tunnel: "/s"
  })
}


startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
      {shouldActivateSentryAndPosthog && <PosthogInit />}
    </StrictMode>
  );
});